import React from "react";
import LegalDocument from "../templates/LegalDocument/legal-document";

export default function LegalNotice() {
  return (
    <LegalDocument title="Legal Notice" effectiveDate="10 September 2026">
      <h2>Website publisher</h2>
      <p>
        ORIGIN GAME, a French simplified joint-stock company (SAS) with share
        capital of EUR 5,000, registered with the Paris Trade and Companies
        Register under number 911 609 394 (SIRET 911 609 394 00018).
      </p>
      <p>
        Registered office: 229 rue Saint-Honore, 75001 Paris, France.
        <br />
        Email: <a href="mailto:contact@oxyaorigin.com">contact@oxyaorigin.com</a>
      </p>

      <h2>Publication director</h2>
      <p>Greg Taieb, President of ORIGIN GAME.</p>

      <h2>Hosting provider</h2>
      <p>
        Cloudflare, Inc.
        <br />
        101 Townsend Street, San Francisco, California 94107, United States
        <br />
        Telephone: +1 650 319 8930
      </p>

      <h2>Intellectual property</h2>
      <p>
        Unless otherwise stated, the website, its text, graphics, logos, visual
        identity, software and other content are protected by applicable
        intellectual-property law. No licence or transfer of rights is granted
        by access to the website. Third-party names, marks and content remain the
        property of their respective owners.
      </p>

      <h2>Information and external links</h2>
      <p>
        Website information may change as the games, services and applicable
        rules evolve. External websites are governed by their own terms and
        policies. ORIGIN GAME does not control their continued availability or
        content.
      </p>

      <h2>Crypto-asset risk notice</h2>
      <p>
        $OXYZ is a crypto-asset. Crypto-assets may lose some or all of their
        value. Website content is not investment advice, a guarantee of utility,
        or a promise of value, liquidity, income or returns. Features and
        availability may change, be limited or be discontinued under the
        applicable rules and terms.
      </p>
    </LegalDocument>
  );
}
